import { useEffect, useState } from 'react';
import { Trash2 } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import { api } from '@/lib/api';

export const EnquiriesTab = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await api.get('/enquiries');
      setItems(data);
    } catch (e) { /* handled by auth guard */ }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm('Delete this enquiry?')) return;
    await api.delete(`/enquiries/${id}`);
    setItems(items.filter((i) => i.id !== id));
  };

  if (loading) return <p className="text-white/40 text-sm">Loading enquiries...</p>;

  return (
    <div data-testid="admin-tab-enquiries">
      <p className="text-white/50 text-sm mb-6">{items.length} enquiry{items.length === 1 ? '' : 'ies'} received.</p>
      <div className="border border-white/10">
        {items.map((q, i) => (
          <div key={q.id} data-testid={`enquiry-row-${q.id}`} className={`px-4 py-4 ${i > 0 ? 'border-t border-white/10' : ''} hover:bg-surface transition-colors`}>
            <div className="flex items-start justify-between gap-4">
              <div className="min-w-0">
                <p className="text-cream text-sm font-medium">{q.name} <span className="text-white/40 font-light">— {q.phone}</span></p>
                <p className="text-champagne text-[11px] uppercase tracking-[0.2em] mt-1">
                  {[q.event_type, q.event_date, q.location, q.budget].filter(Boolean).join(' · ') || 'General enquiry'}
                </p>
                {(q.message || q.requirements) && (
                  <p className="text-white/50 text-sm font-light mt-2">{q.requirements}{q.requirements && q.message ? ' — ' : ''}{q.message}</p>
                )}
                <p className="text-white/30 text-[11px] mt-2">{new Date(q.created_at).toLocaleString('en-IN')}</p>
              </div>
              <div className="flex shrink-0 gap-1">
                <a data-testid={`enquiry-wa-${q.id}`} href={`https://wa.me/${q.phone.replace(/\D/g, '')}`} target="_blank" rel="noopener noreferrer" className="p-2 text-white/50 hover:text-[#25D366] transition-colors" aria-label="WhatsApp">
                  <FaWhatsapp size={16} />
                </a>
                <button data-testid={`enquiry-delete-${q.id}`} onClick={() => remove(q.id)} className="p-2 text-white/50 hover:text-red-400 transition-colors" aria-label="Delete">
                  <Trash2 size={15} />
                </button>
              </div>
            </div>
          </div>
        ))}
        {items.length === 0 && <p className="px-4 py-8 text-center text-white/40 text-sm">No enquiries yet.</p>}
      </div>
    </div>
  );
};
